import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLayout} from '../../../core'
import {usePageData} from '../../../core/PageData'
import { useEffect, useState } from 'react'
import authAPI from '../../../../../api/authAPI'
import LeadServiceAPI from '../../../../../api/LeadServiceAPI'

const PageTitle = () => {
  const {pageTitle, pageDescription, pageBreadcrumbs} = usePageData()
  const {config, classes} = useLayout()
  const appPageTitleDirection = config.app?.pageTitle?.direction
  // const user: any = JSON.parse(localStorage?.getItem('kt-auth-react-v') as any)?.data || {}
  // const [userData, setUserData] = useState<any>({})
  const [companyName, setCompanyName] = useState('')

  useEffect(() => {
    authAPI.getMyProfile().then((res:any) => {
      if(res?.data?.success){
        // setUserData(res?.data?.data)
        getCompanyDetails(res?.data?.data?.company_id)
      }else{
        // setUserData({})
        setCompanyName("")
      }
    })
  },[])
  const getCompanyDetails = (id: number) => {
    LeadServiceAPI.getCompanyDetails(id).then((res: any) => {
      if (res?.data?.success) {
        // setUserData({
        //   ...res?.data?.data,
        //   image: res?.data?.imageFolderPath + '/' + res?.data?.data?.logo,
        // })
        let user = res?.data?.data
        setCompanyName(user?.name)
      } else {
        setCompanyName("")
      }
    })
  }
  return (
    <div
      id='kt_page_title'
      data-kt-swapper='true'
      data-kt-swapper-mode='prepend'
      data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
      className={clsx(
        'd-flex w-100 justify-space-between page-title d-flex flex-wrap me-3',
        classes.pageTitle.join(' '),
        config.app?.pageTitle?.class,
        {
          'flex-column justify-content-center': appPageTitleDirection === 'column',
          'align-items-center': appPageTitleDirection !== 'column',
        }
      )}
    >
      {/* begin::Title */}
      {config.app?.pageTitle?.display && pageTitle && (
        <div className='d-flex w-100 justify-space-between px-5'>
          <h1
            className={clsx('flex-grow-1 page-heading d-flex text-dark fw-bold fs-3 my-0', {
              'flex-column justify-content-center': appPageTitleDirection,
              'align-items-center': !appPageTitleDirection,
            })}
          >
            {pageTitle === 'Dashboard' ? (
              companyName ? (
                <p style={{color: '#5E5555'}}>
                  Welcome, <b>{companyName + ' 👋🏾'}</b>
                </p>
              ) : (
                <p>Welcome 👋🏾</p>
              )
            ) : (
              pageTitle
            )}
            {pageDescription && config.app?.pageTitle && config.app?.pageTitle?.description && (
              <span
                className={clsx('page-desc text-muted fs-7 fw-semibold', {
                  'pt-2': appPageTitleDirection === 'column',
                })}
              >
                {config.app?.pageTitle?.direction === 'row' && (
                  <span className='h-20px border-1 border-gray-300 border-start ms-3 mx-2'></span>
                )}
                {pageDescription}{' '}
              </span>
            )}
          </h1>
          <div className='text-end card-body'>
            <h5 className='card-title'>Subscription</h5>
            <p className='card-text'>Expiry Date: June 30, 2023</p>
          </div>
        </div>
      )}
      {/* end::Title */}

      {pageBreadcrumbs &&
        pageBreadcrumbs.length > 0 &&
        config.app?.pageTitle &&
        config.app?.pageTitle?.breadCrumb && (
          <>
            {config.app?.pageTitle?.direction === 'row' && (
              <span className='h-20px border-gray-300 border-start mx-4'></span>
            )}
            <ul className='breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0'>
              {Array.from(pageBreadcrumbs).map((item, index) => (
                <li
                  className={clsx('breadcrumb-item', {
                    'text-dark': !item.isSeparator && item.isActive,
                    'text-muted': !item.isSeparator && !item.isActive,
                  })}
                  key={`${item.path}${index}`}
                >
                  {!item.isSeparator ? (
                    <Link className='text-muted text-hover-primary' to={item.path}>
                      {item.title}
                    </Link>
                  ) : (
                    <span className='bullet bg-gray-200 w-5px h-2px'></span>
                  )}
                </li>
              ))}
              <li className='breadcrumb-item text-dark'>{pageTitle}</li>
            </ul>
          </>
        )}
    </div>
  )
}

export {PageTitle}
